import React, { Dispatch } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

export const UserDataContext = React.createContext<[IUserData, Dispatch<IUserData>] | null[]>([null, null]);

export const UserDataProvider: React.FC = ({ children }) => {
  const [userData, setUserData] = useLocalStorage('user', {}, true);

  return (
    <UserDataContext.Provider value={[userData, setUserData]}>
      {children}
    </UserDataContext.Provider>
  );
};
